module.exports = __webpack_public_path__ + "img/40372725.3665f3de.png";